var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.14868C2 11.4573 4.69133 14.1487 8 14.1487C11.3087 14.1487 14 11.4573 14 8.14868C14 4.84002 11.3087 2.14868 8 2.14868C4.69133 2.14868 2 4.84002 2 8.14868ZM3 8.14868C3 5.39135 5.24267 3.14868 8 3.14868C10.7573 3.14868 13 5.39135 13 8.14868C13 10.906 10.7573 13.1487 8 13.1487C5.24267 13.1487 3 10.906 3 8.14868ZM8 5.44068C6.50667 5.44068 5.292 6.65602 5.292 8.14935C5.292 9.64268 6.50667 10.8573 8 10.8573C9.49333 10.8573 10.7087 9.64268 10.7087 8.14935C10.7087 6.65602 9.49333 5.44068 8 5.44068ZM4.292 8.14935C4.292 10.194 5.95533 11.8573 8 11.8573C10.0447 11.8573 11.7087 10.194 11.7087 8.14935C11.7087 6.10468 10.0447 4.44002 8 4.44002C5.95533 4.44002 4.292 6.10468 4.292 8.14935ZM8 7.72735C7.77 7.72735 7.58333 7.91401 7.58333 8.14401C7.58333 8.37401 7.77 8.56068 8 8.56068C8.23 8.56068 8.41667 8.37401 8.41667 8.14401C8.41667 7.91401 8.23 7.72735 8 7.72735ZM6.58333 8.14401C6.58333 8.92535 7.21867 9.56068 8 9.56068C8.78133 9.56068 9.41667 8.92535 9.41667 8.14401C9.41667 7.36268 8.78133 6.72735 8 6.72735C7.21867 6.72735 6.58333 7.36268 6.58333 8.14401Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/Target.1172e9178bdb7c4dd77fc3e7f7aa5b04.svg";
export { ForwardRef as ReactComponent };